import React from "react";

export default function LogoBrand({ variant = "sidebar", className = "" }) {
  if (variant === "print") {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <img src="/assets/varuna_logo_sm.png" alt="Varuna Inn" style={{ height: 46, width: "auto" }} />
        <div className="text-slate-900">
          <div className="font-serif text-lg font-semibold">Varuna Inn</div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500">Banquets &amp; Resorts</div>
        </div>
      </div>
    );
  }
  if (variant === "login") {
    return (
      <div className={`flex flex-col items-center gap-3 ${className}`}>
        <img
          src="/assets/varuna_logo.png"
          alt="Varuna Inn"
          className="block mx-auto"
          style={{ height: 72, width: "auto", maxWidth: 260, objectFit: "contain" }}
        />
        <div className="text-xs uppercase tracking-[0.3em] text-slate-500 text-center">Laundry &amp; Asset Management</div>
      </div>
    );
  }
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img src="/assets/varuna_logo_sm.png" alt="Varuna Inn" style={{ height: 38, width: "auto", background: "#ffffff", padding: 4, borderRadius: 6 }} />
    </div>
  );
}
